import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import img from "../IMAGEN/spinner.gif";
import {
  estadosParametrosTipoUsuario,
  obtenerSubEstado,
  obtenerTodosEstados,
} from "../Services/Rest";

const cookies = new Cookies();

const getUrlEndpoint = () => {
  const tipo = cookies.get("tipo_Usuario");
  if (tipo === 1) return obtenerTodosEstados;
  if (tipo === 2 || tipo === 3) return `${estadosParametrosTipoUsuario}${tipo}`;
  return obtenerTodosEstados;
};

function CreaGestion({ id, correoCreador }) {
  const [isLoading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [subEstados, setSubEstados] = useState([]);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [subEstadoSeleccionado, setSubEstadoSeleccionado] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [archivos, setArchivos] = useState(null);

  useEffect(() => {
    const cargarEstados = async () => {
      try {
        const res = await fetch(getUrlEndpoint());
        const data = await res.json();
        setEstados(data.filter((e) => e.id !== 49 && e.id !== 50)); // Filtrar aquí
      } catch (error) {
        console.error("Error cargando estados:", error);
      }
    };
    cargarEstados();
  }, []);

  useEffect(() => {
    if (!estadoSeleccionado) return;
    const cargarSubEstados = async () => {
      try {
        const res = await fetch(obtenerSubEstado + estadoSeleccionado);
        const data = await res.json();
        setSubEstados(data);
      } catch (error) {
        console.error("Error cargando subestados:", error);
      }
    };
    cargarSubEstados();
  }, [estadoSeleccionado]);

  const validarCampos = () => {
    if (!descripcion || !estadoSeleccionado || !subEstadoSeleccionado) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, complete todos los campos obligatorios.",
      });
      return false;
    }
    return true;
  };

  const enviarGestion = async () => {
    if (!validarCampos()) return;

    const urlBase = archivos
      ? "https://educacionapi.azurewebsites.net/api/CreaGestion"
      : "https://educacionapi.azurewebsites.net/api/CreaGestionSinAdjunto";

    const params = new URLSearchParams({
      FechaCreacion: new Date().toLocaleDateString(),
      TipoGestion: "TestGestion",
      SolicitudId: id,
      UsuarioId: cookies.get("id"),
      Estado: estadoSeleccionado,
      DetalleSolicitud: subEstadoSeleccionado,
      DescripcionGestion: descripcion,
      correoGestor: cookies.get("correoGestor"),
      correoCreador: "na",
      Origen: "Educacion",
    });

    try {
      setLoading(true);
      const response = archivos
        ? await axios.post(
            `${urlBase}?${params.toString()}`,
            (() => {
              const f = new FormData();
              for (let i = 0; i < archivos.length; i++)
                f.append("files", archivos[i]);
              return f;
            })()
          )
        : await axios.post(`${urlBase}?${params.toString()}`);

      Swal.fire({
        title: "Gestión guardada con éxito",
        icon: "success",
        timer: 3000,
      }).then(() => window.location.reload()); // O props.onSuccess()
    } catch (error) {
      console.error("Error al enviar la gestión:", error);
      Swal.fire({
        title: "Error al guardar",
        text: "Ocurrió un problema. Intente nuevamente.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 fw-bold text-primary">
            Nueva Gestión {new Date().toLocaleDateString()}
            <span className="visually-hidden"></span>
          </h6>
        </div>
        <div className="card-body">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label>Descripción</label>
              <textarea
                className="form-control"
                rows="5"
                maxLength={600}
                onChange={(e) => setDescripcion(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Archivos (opcional)</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={(e) => setArchivos(e.target.files)}
              />
            </div>
            <div className="form-group">
              <label>Estado</label>
              <select
                className="form-control"
                onChange={(e) => setEstadoSeleccionado(e.target.value)}
              >
                <option value="">Seleccione</option>
                {estados.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.estado}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Subestado</label>
              <select
                className="form-control"
                onChange={(e) => setSubEstadoSeleccionado(e.target.value)}
              >
                <option value="">Seleccione</option>
                {subEstados.map((sub) => (
                  <option key={sub.id} value={sub.id}>
                    {sub.subEstado}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-center">
              {!isLoading ? (
                <button className="btn btn-primary" onClick={enviarGestion}>
                  Guardar
                </button>
              ) : (
                <button className="btn btn-secondary" disabled>
                  <i className="fas fa-spinner fa-spin"></i> Cargando...
                  <img
                    src={img}
                    alt="loading"
                    style={{ width: 70, height: 70 }}
                  />
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreaGestion;
